import React from "react";

const MultiSelect = ({
  label,
  options = [],
  selected = [],
  onChange,
  helper,
  error,
}) => {
  const handleToggle = (optionId) => {
    const newSelected = selected.includes(optionId)
      ? selected.filter((id) => id !== optionId)
      : [...selected, optionId];
    onChange(newSelected);
  };

  return (
    <div className="flex flex-col gap-2 text-sm text-slate-600">
      {label && <label>{label}</label>}
      <div
        className={[
          "max-h-48 overflow-y-auto rounded-lg border p-3 shadow-sm",
          error ? "border-rose-300" : "border-slate-200",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {options.length === 0 ? (
          <p className="text-xs text-slate-400">No options available</p>
        ) : (
          <div className="space-y-2">
            {options.map((option) => (
              <label
                key={option.id}
                className="flex cursor-pointer items-center gap-2 rounded px-2 py-1 hover:bg-slate-50"
              >
                <input
                  type="checkbox"
                  checked={selected.includes(option.id)}
                  onChange={() => handleToggle(option.id)}
                  className="h-4 w-4 rounded border-slate-300 text-[#4f46e5] focus:ring-[#4f46e5]"
                />
                <span className="text-sm text-slate-700">{option.name}</span>
              </label>
            ))}
          </div>
        )}
      </div>
      {helper && !error && (
        <span className="text-xs text-slate-500">{helper}</span>
      )}
      {error && <span className="text-xs text-rose-600">{error}</span>}
    </div>
  );
};

export default MultiSelect;
